export const API_INVOCATION = "API_INVOCATION";
export const SHOW_TOAST_MESSAGE = "SHOW_TOAST_MESSAGE";
export const RESET_SHOW_TOAST_MESSAGE = "RESET_SHOW_TOAST_MESSAGE";
export const START_LOADER = "START_LOADER";
export const STOP_LOADER = "STOP_LOADER";

export const GET_SEARCH_PRODUCT_LIST="GET_SEARCH_PRODUCT_LIST"
export const GET_SEARCH_PRODUCT_LIST_SUCCESS="GET_SEARCH_PRODUCT_LIST_SUCCESS"
export const GET_SEARCH_PRODUCT_LIST_ERROR="GET_SEARCH_PRODUCT_LIST_ERROR"
export const RESET_SEARCH_PRODUCT_LIST="RESET_SEARCH_PRODUCT_LIST"


export const GET_CATEGORY_LIST = "GET_CATEGORY_LIST"
export const GET_CATEGORY_LIST_SUCCESS = "GET_CATEGORY_LIST_SUCCESS"
export const GET_CATEGORY_LIST_ERROR = "GET_CATEGORY_LIST_ERROR"


export const GET_PRODUCT_LIST = "GET_PRODUCT_LIST"
export const GET_PRODUCT_LIST_SUCCESS = "GET_PRODUCT_LIST_SUCCESS"
export const GET_PRODUCT_LIST_ERROR = "GET_PRODUCT_LIST_ERROR"

export const ADD_PRODUCT_TO_CART = "ADD_PRODUCT_TO_CART"
export const ADD_PRODUCT_TO_CART_SUCCESS = "ADD_PRODUCT_TO_CART_SUCCESS"
export const ADD_PRODUCT_TO_CART_ERROR = "ADD_PRODUCT_TO_CART_LIST_ERROR"

export const DELETE_PRODUCT_TO_CART = "DELETE_PRODUCT_TO_CART"
export const DELETE_PRODUCT_TO_CART_SUCCESS = "DELETE_PRODUCT_TO_CART_SUCCESS"
export const DELETE_PRODUCT_TO_CART_ERROR = "DELETE_PRODUCT_TO_CART_ERROR"

export const ADD_VARIANT = "ADD_VARIANT"
export const ADD_VARIANT_SUCCESS = "ADD_VARIANT_SUCCESS"
export const ADD_VARIANT_ERROR = "ADD_VARIANT_ERROR"

export const DELETE_VARIANT = "DELETE_VARIANT"
export const DELETE_VARIANT_SUCCESS = "DELETE_VARIANT_SUCCESS"
export const DELETE_VARIANT_ERROR = "DELETE_VARIANT_ERROR"

export const EMPTY_CART_PRODUCT = "EMPTY_CART_PRODUCT"
export const EMPTY_CART_PRODUCT_SUCCESS = "EMPTY_CART_PRODUCT_SUCCESS"
export const EMPTY_CART_PRODUCT_ERROR = "EMPTY_CART_PRODUCT_ERROR"

export const EMPTY_VARIANT = "EMPTY_VARIANT"
export const EMPTY_VARIANT_SUCCESS = "EMPTY_VARIANT_SUCCESS"
export const EMPTY_VARIANT_ERROR = "EMPTY_VARIANT_ERROR"

export const UPDATE_PRODUCT_TO_CART = "UPDATE_PRODUCT_TO_CART"
export const UPDATE_PRODUCT_TO_CART_SUCCESS = "UPDATE_PRODUCT_TO_CART_SUCCESS"
export const UPDATE_PRODUCT_TO_CART_ERROR = "UPDATE_PRODUCT_TO_CART_ERROR"

export const SET_COUPONS = "SET_COUPONS"
export const SET_COUPONS_SUCCESS = "SET_COUPONS_SUCCESS"
export const SET_COUPONS_ERROR = "SET_COUPONS_ERROR"

export const CREATE_ORDER = "CREATE_ORDER"
export const CREATE_ORDER_SUCCESS = "CREATE_ORDER_SUCCESS"
export const CREATE_ORDER_ERROR = "CREATE_ORDER_ERROR"

export const VERIFY_ORDER_PAYMENT = "VERIFY_ORDER_PAYMENT"
export const VERIFY_ORDER_PAYMENT_SUCCESS = "VERIFY_ORDER_PAYMENT_SUCCESS"
export const VERIFY_ORDER_PAYMENT_ERROR = "VERIFY_ORDER_PAYMENT_ERROR"

export const EMPTY_ORDER_PAYMENT_STATUSES = "EMPTY_ORDER_PAYMENT_STATUSES"
export const EMPTY_ORDER_PAYMENT_STATUSES_SUCCESS = "EMPTY_ORDER_PAYMENT_STATUSES_SUCCESS"
export const EMPTY_ORDER_PAYMENT_STATUSES_ERROR = "EMPTY_ORDER_PAYMENT_STATUSES_ERROR"
  

export const  TOGGLE_USER_FORM_DRAWER ="TOGGLE_USER_FORM_DRAWER"
export const  SELECTED_ADDRESS ="SELECTED_ADDRESS"
export const  LOADER_STATUS ="LOADER_STATUS"



